export default __webpack_public_path__ + "static/media/nethermind-bg.70286d24.png";